import { L10N } from 'global/localization'
import { ButtonColor } from 'global/types/enums'
import type { OrderDetailFooterProps } from 'global/types/props'
import { Button } from 'shared/components/button'
import { formatCurrency } from 'shared/services/utils'

export const PaymentFooter = ({
  total,
  canSubmit = false,
  submitLoading = false,
  onSubmit
}: OrderDetailFooterProps) => (
  <div className='flex flex-row items-center justify-between p-4'>
    <div className='flex flex-col'>
      <div className='text-xs text-neutral'>{L10N.LABEL.TOTAL_PAYMENT}</div>
      <div className='font-heading font-medium text-lg'>{formatCurrency(total)}</div>
    </div>

    <Button
      label={L10N.LABEL.CONTINUE}
      color={ButtonColor.Primary}
      isLoading={submitLoading}
      disabled={!canSubmit}
      onClick={onSubmit}
    />
  </div>
)
